import mediaQueries from "./media-queries";
import editor from "./editor";
import icons from "../imgs/icons";

const wrapper = method => {
  return {
  }
};

const leftCol = {
  ...editor.leftCol,
  [mediaQueries.tablet]: {
    position: "relative"
  }
}

const cropAreaWrapper = {
  position: "absolute",
  top: 0,
  left: 0,
  height: "100%",
  width: "100%",
  cursor: "pointer",
  [mediaQueries.tablet]: {
    background: "#FFFFFF",
    position: "relative",
    top: 0,
    padding: "60% 0 0 0",
    overflow: "hidden",
    border: "1px solid #EDEDED",
    height: "auto"
  }
};

const cropArea = method => {
  return {
    position: "absolute",
    height: "100%",
    width: "100%",
    top: method === "redirect" ? "26vh" : "26%",
    left: 0,
    [mediaQueries.tablet]: {
      paddingTop: 0,
      top: 0
    }
  };
};

const image = method => {
  return {
    position: "absolute",
    margin: "auto",
    height: "100%",
    top: method === "redirect" ? "-26vh" : "-26%",
    left: 0,
    right: 0,
    zIndex: -1,
    [mediaQueries.tablet]: {
      zIndex: 0,
      top: 0
    }
  };
};

const previewBoxWrapper = {
  ...editor.previewWrapper,
  boxShadow: "0 0 0 9999px rgba(255, 255, 255, 0.6)",
  position: "relative",
  margin: "0 30px",
  width: "auto",
  [mediaQueries.tablet]: {
    ...editor.previewWrapper[mediaQueries.tablet],
    zIndex: 1,
    marginTop: "20px",
    width: "74%"
  }
};

const previewBox = {
  ...editor.preview,
  backgroundColor: "transparent"
};

const pinchIcon = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50px",
  [mediaQueries.desktop]: {
    top: "70%"
  }
};

const ctas = method => {
  return {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    position: "relative",
    [mediaQueries.tablet]: {
      marginTop: "40px",
      marginBottom: "auto"
    },
    "& button": {
      flex: "0 0 calc(50% - 10px)",
      [mediaQueries.tablet]: {
        flex: "0 0 100%",
        marginBottom: "10px"
      },
      "&:first-child": {
        [mediaQueries.tablet]: {
          order: 1
        }
      },
      "&:nth-child(3)": {
        marginTop: method === "redirect" ? "2vh" : "2%",
        flex: "0 0 100%",
        [mediaQueries.tablet]: {
          marginTop: 0,
          order: 2
        }
      }
    }
  };
};

const sliderWrapper = {
  margin: "-5px 0 0 0",
  position: "relative",
  display: "none",
  "&:before": {
    content: "''",
    position: "absolute",
    left: 0,
    top: "45px",
    width: "20px",
    height: "16px",
    background: `url(${icons.cropScale}) no-repeat`,
    backgroundSize: "100%"
  },
  "&:after": {
    content: "''",
    position: "absolute",
    right: 0,
    top: "35px",
    width: "35px",
    height: "28px",
    background: `url(${icons.cropScale}) no-repeat`,
    backgroundSize: "100%"
  },
  [mediaQueries.tablet]: {
    display: "block"
  }
};

const warning = method => {
  return {
    alignSelf: "flex-end",
    background: "#D7D2CB",
    padding: "13px 0",
    position: "relative",
    marginTop: method === "redirect" ? "28vh" : "28%",
    minHeight: method === "redirect" ? "20vh" : "20%",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "&:before": {
      bottom: "100%",
      left: "50%",
      border: "solid transparent",
      content: "''",
      height: "0",
      width: "0",
      position: "absolute",
      pointerEvents: "none",
      borderColor: "rgba(215, 210, 203, 0)",
      borderBottomColor: "#D7D2CB",
      borderWidth: "13px",
      marginLeft: "-13px"
    },
    [mediaQueries.tablet]: {
      display: "block",
      minHeight: 0,
      marginTop: "27px"
    }
  };
};

const warningDescription = {
  fontFamily: "JWSansBook",
  fontSize: "16px",
  lineHeight: "22px",
  letterSpacing: "0.6px",
  width: "90%",
  margin: "0 auto"
};

const warningTitle = {
  ...warningDescription,
  fontFamily: "JWSansBold !important",
  fontSize: "14px",
  lineHeight: "24px",
  letterSpacing: "2.62px",
  textTransform: "uppercase"
};

const actionWrapper = {
  marginTop: "30px",
  display: "flex",
  flexFlow: "column",
  [mediaQueries.tablet]: {
    flexFlow: "column-reverse",
    flex: "1 0 auto",
    justifyContent: "flex-start"
  }
};

const desktopInstruction = {
  display: "none",
  fontSize: "12px",
  lineHeight: "16px",
  letterSpacing: "0.45px",
  "& img" : {
    width: '20px',
    marginLeft: '10px',
    marginTop: '10px'
  },
  [mediaQueries.tablet]: {
    display: "block"
  }
};

const cursor = {
  textTransform: "uppercase",
  position: "absolute",
  top: "25%",
  bottom: "auto",
  textAlign: "center",
  fontSize: "19px",
  letterSpacing: "1px",
  paddingLeft: "33px",
  zIndex: 1,
  left: "50%",
  transform: "translateX(-50%)",
  margin: 0,
  "&:before": {
    content: "''",
    width: "40px",
    height: "40px",
    position: "absolute",
    left: 0,
    background: `url(${icons.pinchIcon}) no-repeat`,
    backgroundSize: "100%"
  },
  [mediaQueries.tablet]: {
    display: "block",
    top: "auto",
    bottom: "45%",
    "&:before": {
      background: `url(${icons.cursor}) no-repeat`,
    },
  }
};

export default {
  wrapper,
  leftCol,
  cropAreaWrapper,
  cropArea,
  image,
  previewBoxWrapper,
  previewBox,
  pinchIcon,
  ctas,
  sliderWrapper,
  warning,
  warningDescription,
  warningTitle,
  actionWrapper,
  desktopInstruction,
  cursor
};



// WEBPACK FOOTER //
// ./src/styles/crop.js